<template>
    <div>
        <button @click="openSendMail" class="send-mail-btn">
            <svg width="24" height="24" viewBox="0 0 24 24">
                <path :d="mdiSendCheck" />
            </svg>
        </button>
        <SendMailDialog
            ref="sendMailDialog"
            :room-id="currentRoomId"
            @sent-successfully="handleSentSuccess"
            @send-error="handleSendError"
            @close="handleDialogClose"
        />
    </div>
</template>
<script>
import { mdiEmailArrowRightOutline  } from '@mdi/js';
import SendMailDialog from './SendMailDialog.vue';
import { toast } from 'vue3-toastify';

export default {
    components: {
        SendMailDialog
    },
    props: {
        roomId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            currentRoomId: this.roomId,
            mdiSendCheck: mdiEmailArrowRightOutline 
        }
    },
    methods: {
        openSendMail() {
            this.$refs.sendMailDialog.open();
        },
        handleSentSuccess() {
            toast.success(this.$t('sendMailSuccess'), {
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log('Email sent successfully');
        },
        handleSendError(error) {
            toast.error(this.$t('sendMailError'), {
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log('Failed to send email:', error);
        },
        handleDialogClose() {
            console.log('Mail dialog closed');
        }
    }
};
</script>
<style scoped>
.send-mail-btn {
    position: fixed;
    top: 12px;
    right: 84px;
    padding: 4px;
    border: none;
    cursor: pointer;
    color: var(--text-color);
    display: flex;
    align-items: center;
    background-color: var(--surface-color);
    border-radius: 50%;
    z-index: 9999;
}

.send-mail-btn svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
}

.send-mail-btn:hover {
    background-color: var(--primary-hover);
    border-radius: 50%;
}
</style>